import { buildTestIds } from "application";
import { ReactNode } from "react";
import { RootContainer } from "../PaymentMethods.styles";

interface RootProps {
  children: ReactNode;
}

export const Root = ({ children }: RootProps) => {
  return (
    <RootContainer {...buildTestIds("payment-methods")}>
      {children}
    </RootContainer>
  );
};
